module.exports = __webpack_public_path__ + "static/img/COC2023-18.213d1d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-18.png
// module id = H+KR
// module chunks = 0